import { Button, Modal } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import { ProjectHistoryModel } from '../../../Models/ProjectHistoryModel';
import './styles.css';

interface IModalValuesComponentProps {
    show: boolean,
    toggleShow: () => void,
    project: ProjectHistoryModel
}

const ModalValuesHistoryComponent = (props: IModalValuesComponentProps) => {
    return (
        <Modal show={props.show} onHide={props.toggleShow}>
            <Modal.Header closeButton>
                <Modal.Title>Rúbricas de Orçamento</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex align-items-center'>
                    <div className='w-100'>
                        <div className='text-center w-100 back-head pt-1 pb-1'>Recursos Humanos</div>
                        <div className='input-disabled-style d-flex align-items-center'>
                            <span className='ms-3 font-big'>R$</span>
                            <CurrencyInput
                                id="input-example"
                                name="input-name"
                                className='form-control input-style'
                                intlConfig={{ locale: 'pt-BR' }}
                                placeholder="0,00"
                                value={props.project.rhValue}
                                disabled={true}
                                decimalsLimit={2}
                            />
                        </div>
                    </div>
                    <div className='ms-4 w-100'>
                        <div className='text-center w-100 back-head pt-1 pb-1'>Infraestrutura</div>
                        <div className='input-disabled-style d-flex align-items-center'>
                            <span className='ms-3 font-big'>R$</span>
                            <CurrencyInput
                                id="input-example"
                                name="input-name"
                                className='form-control input-style'
                                intlConfig={{ locale: 'pt-BR' }}
                                placeholder="0,00"
                                value={props.project.infraValue}
                                disabled={true}
                                decimalsLimit={2}
                            />
                        </div>
                    </div>
                </div>
                <div className='d-flex align-items-center mt-4'>
                    <div className='w-100'>
                        <div className='text-center w-100 back-head pt-1 pb-1'>Serviços Terceiros</div>
                        <div className='input-disabled-style d-flex align-items-center'>
                            <span className='ms-3 font-big'>R$</span>
                            <CurrencyInput
                                id="input-example"
                                name="input-name"
                                className='form-control input-style'
                                intlConfig={{ locale: 'pt-BR' }}
                                placeholder="0,00"
                                value={props.project.invoiceValue}
                                disabled={true}
                                decimalsLimit={2}
                            />
                        </div>
                    </div>
                    <div className='ms-4 w-100'>
                        <div className='text-center w-100 back-head pt-1 pb-1'>Aquisição de Equipamentos</div>
                        <div className='input-disabled-style d-flex align-items-center'>
                            <span className='ms-3 font-big'>R$</span>
                            <CurrencyInput
                                id="input-example"
                                name="input-name"
                                className='form-control input-style'
                                intlConfig={{ locale: 'pt-BR' }}
                                placeholder="0,00"
                                value={props.project.equipmentValue}
                                disabled={true}
                                decimalsLimit={2}
                            />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className='btn btn-primary' onClick={props.toggleShow}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalValuesHistoryComponent;